import SalesOrder from './SalesOrder';

export default SalesOrder;
